(function () {
  const STORAGE_KEY = 'infospeed:recently-viewed';
  const MAX_STORED = 12;
  const MAX_SHOWN = 4;

  const SPINNER_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">' +
    '<circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>';

  // Mirrors snippets/buy-buttons.liquid's <product-form> markup (native
  // Dawn add-to-cart, with its loading-spinner and cart-drawer wiring from
  // assets/product-form.js) so this client-rendered card behaves identically
  // to the real product page instead of a bespoke fetch call.
  function renderAddToCartForm(variantId, available, label) {
    const disabled = available === false || !variantId ? ' disabled' : '';
    return (
      '<product-form class="catalog-product-card__form" data-hide-errors="true">' +
        '<form method="post" action="/cart/add" class="form" novalidate="novalidate" data-type="add-to-cart-form">' +
          '<input type="hidden" name="id" value="' + escapeHtmlStatic(variantId) + '" class="product-variant-id"' + disabled + '>' +
          '<button type="submit" name="add" class="button button--accent catalog-product-card__button"' + disabled + '>' +
            '<span>' + escapeHtmlStatic(label) + '</span>' +
            '<div class="loading__spinner hidden">' + SPINNER_SVG + '</div>' +
          '</button>' +
        '</form>' +
      '</product-form>'
    );
  }

  function escapeHtmlStatic(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function getViewed() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function recordView(handle) {
    if (!handle) return;
    try {
      let handles = getViewed().filter((existing) => existing !== handle);
      handles.unshift(handle);
      handles = handles.slice(0, MAX_STORED);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      // localStorage unavailable (private mode, quota, etc.) — fail silently.
    }
  }

  const currentProductEl = document.querySelector('[data-recently-viewed-current]');
  const currentHandle = currentProductEl
    ? currentProductEl.getAttribute('data-recently-viewed-current')
    : null;

  if (currentHandle) recordView(currentHandle);

  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-recently-viewed-grid]');
      this.slider = this.querySelector('slider-component');
      this.moneyFormat = this.getAttribute('data-money-format') || '{{amount}}';
      this.removeLabel = this.getAttribute('data-remove-label') || '';
      this.taxNotice = this.getAttribute('data-tax-notice') || '';
      this.buttonLabel = this.getAttribute('data-button-label') || 'Adaugă în coș';
      this.imageRatio = this.getAttribute('data-image-ratio') || 'square';

      const heartIconTemplate = this.querySelector('[data-heart-icon]');
      this.heartIconMarkup = heartIconTemplate ? heartIconTemplate.innerHTML : '';

      this.renderFromStorage();
    }

    async renderFromStorage() {
      const handles = getViewed()
        .filter((handle) => handle !== currentHandle)
        .slice(0, MAX_SHOWN);

      if (!handles.length) {
        this.hidden = true;
        return;
      }

      const products = await Promise.all(
        handles.map((handle) =>
          fetch('/products/' + handle + '.js')
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null)
        )
      );

      // Re-filter the current product out by its actual (guaranteed non-empty)
      // handle from the fetched data, not just the attribute read earlier —
      // a defensive second pass in case that attribute was ever missing/empty.
      const validProducts = products.filter((product) => product && product.handle !== currentHandle);

      if (!validProducts.length || !this.grid) {
        this.hidden = true;
        return;
      }

      this.grid.innerHTML = validProducts
        .map((product, index) => this.renderCard(product, index))
        .join('');

      // Only reveal the section once the grid actually has rendered slides —
      // never trust the fetched-product count alone.
      this.hidden = this.grid.children.length === 0;

      if (this.slider && typeof this.slider.resetPages === 'function') {
        this.slider.resetPages();
      }
    }

    renderCard(product, index) {
      const rawImage = product.featured_image || (product.images && product.images[0]);
      const image = this.resizeImage(rawImage, 400);
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const defaultVariant = variants.find((variant) => variant.available) || variants[0] || product;
      const variantPrice = defaultVariant.price != null ? defaultVariant.price : product.price;
      const variantCompareAtPrice = defaultVariant.compare_at_price != null
        ? defaultVariant.compare_at_price
        : product.compare_at_price;
      const formatMoney = window.Wishlist && window.Wishlist.formatMoney;
      const price = formatMoney
        ? formatMoney(variantPrice, this.moneyFormat) + (this.taxNotice ? ' ' + this.escapeHtml(this.taxNotice) : '')
        : '';
      const hasCompareAt = variantCompareAtPrice && variantCompareAtPrice > variantPrice;
      const compareAtPrice = hasCompareAt && formatMoney ? formatMoney(variantCompareAtPrice, this.moneyFormat) : '';
      const isWishlisted = window.Wishlist ? window.Wishlist.isWishlisted(product.handle) : false;
      const isComingSoon = Array.isArray(product.tags) && product.tags.indexOf('in-curand') > -1;
      const url = '/products/' + product.handle;
      const shortDescription = this.truncateWords(this.stripHtml(product.description || ''), 22);
      const ratioClass = this.imageRatio === 'portrait' ? 'portrait' : 'square';

      const priceMarkup =
        '<div class="price' + (hasCompareAt ? ' price--on-sale' : '') + '">' +
          '<div class="price__container">' +
            '<div class="price__regular">' +
              '<span class="price-item price-item--regular">' + this.escapeHtml(price) + '</span>' +
            '</div>' +
            '<div class="price__sale">' +
              (compareAtPrice
                ? '<span><s class="price-item price-item--regular">' + this.escapeHtml(compareAtPrice) + '</s></span>'
                : '') +
              '<span class="price-item price-item--sale price-item--last">' + this.escapeHtml(price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';

      return (
        '<li id="Slide-RecentlyViewed-' + (index + 1) + '" class="grid__item slider__slide">' +
          '<div class="catalog-product-card">' +
            '<div class="catalog-product-card__media-wrapper">' +
              '<a href="' + this.escapeHtml(url) + '" class="catalog-product-card__media-link">' +
                '<div class="catalog-product-card__media catalog-product-card__media--' + ratioClass + (isComingSoon ? ' catalog-product-card__media--bordered' : '') + '">' +
                  (image
                    ? '<img src="' + this.escapeHtml(image) + '" alt="' + this.escapeHtml(product.title) + '" loading="lazy" width="700" height="700">'
                    : '') +
                '</div>' +
              '</a>' +
              '<button type="button" class="wishlist-button' + (isWishlisted ? ' is-active' : '') + '" data-wishlist-toggle data-product-handle="' + this.escapeHtml(product.handle) + '" aria-pressed="' + isWishlisted + '">' +
                '<span class="svg-wrapper wishlist-button__icon">' + this.heartIconMarkup + '</span>' +
                '<span class="visually-hidden">' + this.escapeHtml(this.removeLabel) + '</span>' +
              '</button>' +
            '</div>' +
            '<div class="catalog-product-card__content">' +
              '<h3 class="catalog-product-card__title"><a href="' + this.escapeHtml(url) + '">' + this.escapeHtml(product.title) + '</a></h3>' +
              (shortDescription
                ? '<p class="catalog-product-card__description">' + this.escapeHtml(shortDescription) + '</p>'
                : '') +
              '<div class="catalog-product-card__price">' + priceMarkup + '</div>' +
              '<div class="catalog-product-card__actions">' +
                renderAddToCartForm(defaultVariant.id, defaultVariant.available, this.buttonLabel) +
              '</div>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }

    stripHtml(value) {
      const div = document.createElement('div');
      div.innerHTML = value == null ? '' : String(value);
      return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
    }

    truncateWords(value, count) {
      const words = value.split(' ').filter(Boolean);
      if (words.length <= count) return value;
      return words.slice(0, count).join(' ') + '…';
    }

    resizeImage(url, size) {
      if (!url) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
    }

    escapeHtml(value) {
      const div = document.createElement('div');
      div.textContent = value == null ? '' : String(value);
      return div.innerHTML;
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }
})();
